import BreadCrumbs from 'components/breadcrumbs'
import React, { useEffect } from 'react'
import TableReport from '../TableReport'
import { formatDateOnlyPMBV1 } from 'utils/formatDate'
import { useFetchAttendanceReportQuery } from '../reportAttendanceApiSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import {
  URL_ATTENDANCE_REPORT,
  URL_ATTENDANCE_REPORT_MEMBER,
  URL_ATTENDANCE_TODAY,
} from 'utils/pathUrl'
import moment from 'moment-timezone'
import { Spinner } from 'reactstrap'
import { setFetchOption } from '../reportAttendanceSlice'

const IndividualReport = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const dataState = location.state || {}
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get('id')
  const { loading, tag } = useSelector((s) => s.reportAttendance)
  const today = moment().endOf('day').toDate()
  const threeMonthsAgo = moment(today)
    .subtract(3, 'months')
    .startOf('day')
    .toDate()
  const queryArgs = {
    ...tag,

    byUserId: id,
  }
  const res = useFetchAttendanceReportQuery(queryArgs, { skip: !tag })

  useEffect(() => {
    dispatch(
      setFetchOption({
        from: dataState?.from ?? threeMonthsAgo.toISOString(),
        to: dataState?.to ?? today.toISOString(),
        s: undefined,
      }),
    )
  }, [dataState?.from, dataState?.to])

  return (
    <div className="w-100 px-3">
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs
          breadCrumbParent={
            dataState?.noAction
              ? 'Laporan Absensi Anggota'
              : dataState?.today
                ? 'Laporan Hari Ini'
                : 'Ringkasan'
          }
          breadCrumbParentLink={
            dataState?.noAction
              ? URL_ATTENDANCE_REPORT_MEMBER
              : dataState?.today
                ? URL_ATTENDANCE_TODAY
                : URL_ATTENDANCE_REPORT
          }
          breadCrumbActive={'Absensi Karyawan'}
        />
      </div>
      <TableReport
        title={
          res?.status === 'pending' ? (
            <Spinner />
          ) : (
            (dataState?.name ?? res?.data?.items?.[0]?.verifiedprofile?.name)
          )
        }
        // subTitle={`Absensi ${month}`}
        data={res?.data}
        queryArgs={queryArgs}
        showDate
        loading={res?.status === 'pending'}
        refetch={res?.refetch}
        defaultDateRange={[
          tag?.from
            ? formatDateOnlyPMBV1(tag.from)
            : formatDateOnlyPMBV1(threeMonthsAgo),
          tag?.to ? formatDateOnlyPMBV1(tag.to) : formatDateOnlyPMBV1(today),
        ]}
      />
    </div>
  )
}

export default IndividualReport
